var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { cn } from "../../lib/utils";
import { injectGlobal } from '@emotion/css';
import * as React from 'react';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var _styles = injectGlobal(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .moly-space-compact.moly-space-vertical {\n    display: inline-block;\n  }\n\n  .moly-space-compact.moly-space-vertical .moly-space-item {\n    width: 100%;\n  }\n\n  .moly-space-compact.moly-space-vertical .moly-space-item > button {\n    width: 100%;\n  }\n\n  .moly-space-compact\n    .moly-space-item:not(.moly-space-item-first):not(.moly-space-item-last)\n    > button {\n    border-radius: 0;\n  }\n\n  .moly-space-compact .moly-space-item {\n    position: relative;\n  }\n\n  .moly-space-compact:not(.moly-space-vertical)\n    .moly-space-item-first\n    ~ .moly-space-item {\n    margin-left: -1px;\n  }\n\n  .moly-space-compact.moly-space-vertical\n    .moly-space-item-first\n    ~ .moly-space-item {\n    margin-top: -1px;\n  }\n\n  .moly-space-compact .moly-space-item-first ~ .moly-space-item::before {\n    position: absolute;\n    background-color: var(--bds-static-border-color);\n    content: ' ';\n  }\n\n  .moly-space-compact:not(.moly-space-vertical)\n    .moly-space-item-first\n    ~ .moly-space-item::before {\n    width: 1px;\n    height: 100%;\n  }\n\n  .moly-space-compact.moly-space-vertical\n    .moly-space-item-first\n    ~ .moly-space-item::before {\n    width: 100%;\n    height: 1px;\n  }\n\n  .moly-space-compact:not(.moly-space-vertical)\n    .moly-space-item-first\n    > button {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .moly-space-compact:not(.moly-space-vertical) .moly-space-item-last > button {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .moly-space-compact.moly-space-vertical .moly-space-item-first > button {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .moly-space-compact.moly-space-vertical .moly-space-item-last > button {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .moly-space-compact .moly-space-item > button:hover {\n    position: relative;\n    z-index: 2;\n  }\n"])));
var Space = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    size = props.size,
    align = props.align,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
    wrap = props.wrap,
    split = props.split,
    compact = props.compact,
    style = props.style;
  var _align = align || (direction === 'horizontal' ? 'center' : 'start');
  var getGap = function getGap() {
    var sizeArr = Array.isArray(size) ? size : [size, size];
    var newSize = sizeArr.map(function (size) {
      if (typeof size === 'number') {
        return "".concat(size, "px");
      } else if (size === 'middle') {
        return "16px";
      } else if (size === 'large') {
        return '24px';
      }
      return '8px';
    });
    return newSize.join(' ');
  };
  return /*#__PURE__*/_jsx("div", {
    className: cn('moly-space flex', {
      'flex-col inline-flex moly-space-vertical': direction === 'vertical',
      'items-center': _align === 'center' || direction === 'horizontal',
      'items-start': _align === 'start',
      'items-end': _align === 'end',
      'items-baseline': _align === 'baseline',
      'flex-wrap': wrap,
      'moly-space-compact': compact
    }, className),
    style: compact ? {} : {
      gap: getGap()
    },
    ref: ref,
    children: React.Children.map(children, function (child, index) {
      if (!child) {
        return null;
      }
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          style: style,
          className: cn('moly-space-item', {
            'w-full': _align === 'stretch',
            'moly-space-item-first': index === 0,
            'moly-space-item-last': index === React.Children.count(children) - 1
          }),
          children: child
        }), split && /*#__PURE__*/_jsx("div", {
          className: "moly-space-split last:hidden",
          children: split
        })]
      }, index);
    })
  });
});
Space.displayName = 'Space';
export { Space };